import { FC } from "react";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import * as Styled from "./MissingContractContextErrorStep.styled";

export const MissingContractContextErrorStep: FC = () => {
    const { t } = useTypedTranslation();

    return (
        <Styled.MissingContractContextErrorStepWrapper>
            <Styled.MissingContractContextErrorStepTitle variant="h6">
                {t("investmentStrategy.errorMessages.missingContractContextTitle")}
            </Styled.MissingContractContextErrorStepTitle>
            <Styled.MissingContractContextErrorStepText variant="body1">
                {t("investmentStrategy.errorMessages.missingContractContext")}
            </Styled.MissingContractContextErrorStepText>
        </Styled.MissingContractContextErrorStepWrapper>
    );
};
